export default function (parameters = {}) {
  const shape = (parameters || {}).output_shape_user || [1, 1];
  return `${shape[0]}:${shape[1]}`;
}
